import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./sideBar.css";

const SideBar = () => {
  const { user } = useAuth();
  if (!user) return null; // Ensure user is logged in

  const menuItems = user.menus || []; // Ensure it's always an array

  const parentMenus = menuItems
    .filter((menu) => menu.parentMenuID === null)
    .sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        {parentMenus.map((parent) => {
          const childMenus = menuItems
            .filter((menu) => menu.parentMenuID === parent.menuID)
            .sort((a, b) => a.displayOrder - b.displayOrder);

          return (
            <li key={parent.menuID} className="nav-item">
              {/* ✅ Parent Menu */}
              <NavLink
                to={parent.url}
                className={({ isActive }) =>
                  `nav-link ${childMenus.length > 0 ? "collapsed" : ""} ${
                    isActive ? "active" : ""
                  }`
                }
                data-bs-toggle={childMenus.length > 0 ? "collapse" : undefined}
                data-bs-target={childMenus.length > 0 ? `#menu-${parent.menuID}` : undefined}
                aria-expanded="false"
              >
                {/* ✅ Fix: Only Render Icon If It Exists */}
                {parent.icon && <i className={`me-2 ${parent.icon}`}></i>}
                <span>{parent.menuName}</span>
                {childMenus.length > 0 && <i className="bi bi-chevron-down ms-auto"></i>}
              </NavLink>

              {/* ✅ Child Menus (Collapsible) */}
              {childMenus.length > 0 && (
                <ul
                  id={`menu-${parent.menuID}`}
                  className="nav-content collapse"
                  data-bs-parent="#sidebar-nav"
                >
                  {childMenus.map((child) => (
                    <li key={child.menuID}>
                      <NavLink
                        to={child.url}
                        className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                      >
                        {/* ✅ Fix: Only Render Icon If It Exists */}
                        {child.icon && <i className={`me-2 ${child.icon}`}></i>}
                        {child.menuName}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default SideBar;
